module.exports = __webpack_public_path__ + "static/media/promo-how-to-v5.30b5e559.png";